// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3N2N3","top":"styles_top__hB_Qj"};